import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

export default function BasicInfoTab() {
  return (
    <>
      {/* Upload */}
      <div className="upload-box text-center mb-3">
        <p>Upload Profile Image</p>
        <Button className="btn-orange">Upload</Button>
      </div>

      <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Company Name *</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Phone *</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Website</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Owner *</Form.Label>
            <Form.Select>
              <option>Select</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Deals *</Form.Label>
            <Form.Select>
              <option>Select</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Group>
            <Form.Label>About</Form.Label>
            <Form.Control as="textarea" rows={3} />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}